import user from './user'
import home from './home'
import car from './car'
import tk from './tk'
import tr from './tr'
import ht from './ht'
import common from './common'
import approval from './approval'
import visa from './visa'
import airService from './airService'

export default [
  ...common,
  ...user,
  ...home,
  ...car,
  ...tk,
  ...ht,
  ...tr,
  ...approval,
  ...visa,
  ...airService
]
